import stickybits from 'stickybits';

$(function() {
  stickybits(".js-sticky", { useStickyClasses: true });


  // Mobile nav: Prevent double scroll when collapsed menu is visible
  const $nav = $('.ecommerce-mobile-nav-v2 .navbar');
  if($nav.length) {
    $nav.on('show.bs.collapse', function () {
      $('body').css('overflow-y', 'hidden');
    });
    $nav.on('hide.bs.collapse', function () {
      $('body').css('overflow-y', 'scroll');
    });
  }

  // Desktop nav: Prevent closing nav dropdown if clicking on nested collapse toggles
  const $dropdownWithToggles = $('.ecommerce-nav-v2 .js-dropdown-menu-with-toggles [data-toggle="collapse"]');
  if($dropdownWithToggles.length) {
    console.log("found dropdown with toggles")
    $(document).on('click', '.ecommerce-nav-v2 .js-dropdown-menu-with-toggles [data-toggle="collapse"]', function (e) {
      console.log("clicked on togglw")
      e.stopPropagation(); // prevent dropdown from closing
    });
  }
});
